"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatetime = _interopRequireDefault(require("react-datetime"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CalendarContainer = _interopRequireDefault(require("react-datetime/src/CalendarContainer"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _Input = _interopRequireDefault(require("./Input"));

var _DateIcon = _interopRequireDefault(require("../Icons/DateIcon"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Date picker component overriding react-datetime.
 * See https://github.com/YouCanBookMe/react-datetime for complete API.
 */
var DatePicker =
/*#__PURE__*/
function (_DateTime) {
  _inherits(DatePicker, _DateTime);

  function DatePicker() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatePicker)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.renderCalendar = function () {
      //
      // Dont render calender if the open state is false.
      // Adding this condition since renderCalendar will be called on prop update
      // Due to which the calender is rendering without even clicking/focusing
      // on the input.
      //
      if (!_this.state.open) {
        return;
      } // Getting the position of the input to place the calender next
      // to the input box.


      var popupContainer = _this.getPopupContainer();

      var datePickerPosition = _this.createPopupContainerPosition(_this.inputNode, popupContainer); //
      // Check if a div is already created to which the calendar
      // will get rendered. If already created will directly render
      // the calendar to it.
      //


      if (!_this.el) {
        _this.el = document.createElement('div');
        popupContainer.appendChild(_this.el);
      }

      if (_this.props.timeFormat) {
        throw new Error('Do not use timeFormat in datepicker component');
      }

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      _reactDom.default.render(_react.default.createElement("div", {
        className: (0, _classnames.default)("rdt ".concat(clsPrfx, " ").concat(clsPrfx, "-date-picker date-picker"), _this.props.popupClassName, "date-picker-placed-".concat(_this.props.renderPosition))
      }, _react.default.createElement("div", {
        className: "date-picker-mask"
      }), _react.default.createElement("div", {
        className: "rdtPicker",
        style: datePickerPosition
      }, _react.default.createElement(ClickableWrapper, {
        onClickOut: _this.handleClickOutside
      }, _react.default.createElement(_CalendarContainer.default
      /* currentView is the state maintained by react-datetime to
       determine and set the view of the calender */
      , {
        view: _this.state.currentView,
        viewProps: _this.getComponentProps()
      })))), _this.el);
    }, _this.getPopupContainer = function () {
      var popupContainer;

      if (_this.props.getPopupContainer) {
        popupContainer = _this.props.getPopupContainer();
      } else {
        popupContainer = document.body;
      }

      return popupContainer;
    }, _this.closeCalendar = function () {
      _this.setState({
        open: false
      }, function () {
        _reactDom.default.unmountComponentAtNode(_this.el);

        _this.getPopupContainer().removeChild(_this.el);

        _this.el = null;
      });
    }, _this.handleClickOutside = function (e) {
      var input = _this.inputNode;

      if (!(input && input.contains(e.target)) && _this.props.input && _this.state.open && !_this.props.open) {
        _this.closeCalendar();
      }
    }, _this.updateSelectedDate = function (e, close) {
      var _this$props = _this.props,
          closeOnSelect = _this$props.closeOnSelect,
          value = _this$props.value;

      _get(_getPrototypeOf(DatePicker.prototype), "updateSelectedDate", _assertThisInitialized(_this)).call(_assertThisInitialized(_this), e, close); // Only need to close when no value is provided. DateTime updateSelectedDate handles close
      // calendar state differently based on value prop being passed in.


      if (closeOnSelect && !value) {
        _this.setState({
          open: false
        }, _this.closeCalendar);
      }
    }, _temp));
  }

  _createClass(DatePicker, [{
    key: "componentDidUpdate",

    /**
     * Since DateTime is appending the calender container next to the input box
     * we will have the z-index problem. To overcome this we are extending DateTime
     * and overriding certain function like
     * rendering calender - where we will append the calendar to the body using
     * ReactDom.render
     * Closing calendar - Unmounting the appended Calendar container.
     * Handle click outside - which will call closeCalender.
     * @param {object} prevProps - prevProps.
     * @param {object} prevState - prevState.
     */
    value: function componentDidUpdate(prevProps, prevState) {
      this.renderCalendar();
    }
    /**
     * Render calender to the body, by calculating the position
     * of the text box and render it next to it.
     */

  }, {
    key: "createPopupContainerPosition",

    /**
     * Create a position where to place the popup based on the where the anchor is.
     * @param {node} anchor - spot where popup container should display
     * @param {node} [popupContainer] - popup container used for offset positioning
     * @returns {object} of top & left position
     */
    value: function createPopupContainerPosition(anchor, popupContainer) {
      var position = {};

      if (anchor) {
        var inputEl = anchor.getBoundingClientRect();
        var containerEl = popupContainer.getBoundingClientRect(); // (no-mixed-operators)
        // eslint-disable-next-line

        var topPos = inputEl.top - containerEl.top + popupContainer.scrollTop + inputEl.height; // (no-mixed-operators)
        // eslint-disable-next-line

        var leftPos = inputEl.left - containerEl.left + popupContainer.scrollLeft;
        position = {
          top: "".concat(topPos, "px"),
          left: "".concat(leftPos, "px")
        };
      } else {
        position = {
          top: '0px',
          left: '0px'
        };
      }

      return position;
    }
    /**
     * @override
     * Overriding the close calendar function for unmounting the attached node.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      var inputProps = _objectSpread({
        key: 'i',
        type: 'text',
        className: "".concat(clsPrfx, "-input"),
        onFocus: this.openCalendar,
        onChange: this.onInputChange,
        onKeyDown: this.onInputKey,
        value: this.state.inputValue,
        disabled: this.props.disabled
      }, this.props.inputProps);

      var datePickerIconClick;
      var dateIconClassName = "".concat(clsPrfx, "-datepicker-icon-disabled");

      if (!this.props.disabled) {
        datePickerIconClick = this.openCalendar;
        dateIconClassName = "".concat(clsPrfx, "-datepicker-icon");
      }
      /**
       * @param {element} node - The input node element
       * Using ref for calculating the position of the input box
       * in renderCalendar method.
       */


      return _react.default.createElement("div", {
        className: (0, _classnames.default)("".concat(clsPrfx, " ").concat(clsPrfx, "-datepicker-input")),
        ref: function ref(node) {
          _this2.inputNode = node;
        }
      }, _react.default.createElement(_Input.default, _extends({
        suffix: _react.default.createElement(_DateIcon.default, {
          onClick: datePickerIconClick,
          className: dateIconClassName,
          color: _ThemeManager.default.getVar('gray-2')
        }),
        placeholder: this.props.placeholder
      }, inputProps)));
    }
  }]);

  return DatePicker;
}(_reactDatetime.default);
/**
 * @override (re-defining original logic from date-time)
 * Wrapper container to handle outside clicks of calendar
 */


exports.default = DatePicker;
DatePicker.defaultProps = {
  className: '',
  closeOnSelect: true,
  closeOnTab: true,
  dateFormat: true,
  defaultValue: '',
  disabled: false,
  inputProps: {},
  input: true,

  /* eslint-disable no-empty-function */
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onNavigateBack: function onNavigateBack() {},
  onNavigateForward: function onNavigateForward() {},
  onViewModeChange: function onViewModeChange() {},

  /* eslint-enable */
  timeFormat: false,
  timeConstraints: {},
  strictParsing: true,
  placeholder: _I18nManager.default.t('DatePicker', 'placeholder'),
  renderPosition: 'bottom',
  utc: false
};
DatePicker.propTypes = {
  /**
   * Customizable placeholder text.
   */
  placeholder: _propTypes.default.string,

  /**
   * Customize additional class name to the popup.
   */
  popupClassName: _propTypes.default.string,

  /**
   * Custom class name for DatePicker.
   */
  className: _propTypes.default.string,

  /**
   * When true, once the day has been selected, the datepicker will be
   * automatically closed.
   */
  closeOnSelect: _propTypes.default.bool,

  /**
   * When true and the input is focused, pressing the tab key will close the datepicker.
   */
  closeOnTab: _propTypes.default.bool,

  /**
   * Defines the format for the date. It accepts any Moment.js date format (not in localized
   * format). If true the date will be displayed using the defaults for the current locale. If
   * false the datepicker is disabled and the component can be used as timepicker, see available
   * units docs: https://www.npmjs.com/package/react-datetime#specify-available-units
   */
  dateFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),

  /**
   * Represents the selected date for the component to use it as a uncontrolled component. This
   * prop is parsed by Moment.js, so it is possible to use a date string or a moment object.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),

  /**
   * Disabled prop is used to disable the Datepicker.
   */
  disabled: _propTypes.default.bool,

  /**
   * Whether to show an input field to edit the date manually.
   */
  input: _propTypes.default.bool,

  /**
   * Defines additional attributes for the input element of the component. For example: onClick,
   * placeholder, disabled, required, name and className (className sets the class attribute for
   * the input element). See Customize the Input Appearance:
   * https://www.npmjs.com/package/react-datetime#customize-the-input-appearance
   */
  inputProps: _propTypes.default.object,

  /**
   * Callback trigger for when the user clicks outside of the input, simulating a regular onBlur.
   * The callback receives the selected moment object as only parameter, if the date in the input
   * is valid. If the date in the input is not valid, the callback returned.
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback trigger when the date changes. The callback receives the selected moment object as
   * only parameter, if the date in the input is valid. If the date in the input is not valid,
   * the callback receives the value of the input (a string).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback trigger for when the user opens the datepicker. The callback receives an event of
   * type SyntheticEvent.
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback trigger when the user navigates to the previous month, year or decade. The callback
   * receives the amount and type ('month', 'year') as parameters.
   */
  onNavigateBack: _propTypes.default.func,

  /**
   * Callback trigger when the view mode changes. The callback receives the selected view mode
   * string (years, months, days or time) as only parameter.
   */
  onViewModeChange: _propTypes.default.func,

  /**
   * Callback trigger when the user navigates to the next month, year or decade. The callback
   * receives the amount and type ('month', 'year') as parameters.
   */
  onNavigateForward: _propTypes.default.func,

  /**
   * Placement of the date picker popup.
   * top or bottom
   */
  renderPosition: _propTypes.default.oneOf(['top', 'bottom']),

  /**
   * Whether to use Moment.js's strict parsing when parsing input.
   */
  strictParsing: _propTypes.default.bool,

  /**
   * Add some constraints to the timepicker. It accepts an object with the format
   * { hours: { min: 9, max: 15, step: 2 }}, this example means the hours can't be lower than 9
   * and higher than 15, and it will change adding or subtracting 2 hours everytime the buttons
   * are clicked. The constraints can be added to the hours, minutes, seconds and milliseconds.
   */
  timeConstraints: _propTypes.default.object,

  /**
   * Always forcing to false since we are not using Timepicker component
   * from react-dateTime.
   */
  timeFormat: _propTypes.default.bool,

  /**
   * Parent Node which the Date picker should be rendered to.
   * Default to body
   */
  getPopupContainer: _propTypes.default.func,

  /**
   * Locale is to set the locale for the date picker instance
   */
  locale: _propTypes.default.string,

  /**
   * When true, input time values will be interpreted as UTC (Zulu time) by Moment.js. Otherwise
   * they will default to the user's local timezone.
   */
  utc: _propTypes.default.bool
};
var ClickableWrapper = (0, _reactOnclickoutside.default)((0, _createReactClass.default)({
  render: function render() {
    return _react.default.createElement('div', {
      className: this.props.className
    }, this.props.children);
  },
  handleClickOutside: function handleClickOutside(e) {
    this.props.onClickOut(e);
  }
}));